import { Star } from "lucide-react";
import { TESTIMONIALS } from "@/data/site";
import { Reveal } from "./Reveal";

const Stars = () => (
  <div className="flex gap-1 text-[#D4AF37]">
    {[...Array(5)].map((_, i) => (
      <Star key={i} size={15} fill="currentColor" strokeWidth={0} />
    ))}
  </div>
);

export const Testimonials = () => (
  <section id="depoimentos" data-testid="testimonials-section" className="py-16 sm:py-24 lg:py-32 bg-white">
    <div className="max-w-7xl mx-auto px-4 sm:px-8 lg:px-12">
      <Reveal>
        <div className="flex flex-col lg:flex-row lg:items-end lg:justify-between gap-6">
          <div>
            <p className="text-xs sm:text-sm font-medium tracking-[0.25em] uppercase text-[#C2185B]">
              Depoimentos
            </p>
            <h2 className="mt-4 font-serif-display text-3xl sm:text-4xl lg:text-5xl font-semibold tracking-tight text-stone-900">
              Quem visita, <em className="text-[#C2185B]">volta sempre</em>
            </h2>
          </div>
          <div
            data-testid="google-rating-badge"
            className="inline-flex items-center gap-3 bg-[#FFF0F5] border border-rose-100 rounded-2xl px-5 py-3.5 self-start"
          >
            <span className="font-serif-display text-3xl font-semibold text-stone-900">5.0</span>
            <div>
              <Stars />
              <p className="text-xs text-stone-500 mt-1">Avaliações de clientes</p>
            </div>
          </div>
        </div>
      </Reveal>

      <div className="mt-12 grid sm:grid-cols-2 lg:grid-cols-4 gap-6">
        {TESTIMONIALS.map((t, i) => (
          <Reveal key={t.name} delay={i * 0.08}>
            <figure
              data-testid="testimonial-card"
              className="h-full bg-[#FAF8F5] rounded-3xl p-7 border border-rose-100/70 hover:border-[#C2185B]/30 hover:shadow-xl hover:shadow-[#C2185B]/10 transition-all duration-500 hover:-translate-y-1.5 flex flex-col"
            >
              <Stars />
              <blockquote className="mt-4 text-sm text-stone-700 leading-relaxed flex-1">
                “{t.text}”
              </blockquote>
              <figcaption className="mt-6 pt-5 border-t border-rose-100 flex items-center gap-3">
                <span className="w-10 h-10 rounded-full bg-[#C2185B]/10 text-[#C2185B] font-serif-display font-semibold flex items-center justify-center">
                  {t.name.charAt(0)}
                </span>
                <span>
                  <span className="block text-sm font-semibold text-stone-900">{t.name}</span>
                  <span className="block text-xs text-[#C2185B]">{t.service}</span>
                </span>
              </figcaption>
            </figure>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
